import _module, { createRequire } from "node:module";
const requireResolve = (id, from) => {
  let resolvedID = id;
  if (process.versions.pnp && "findPnpApi" in _module && typeof _module.findPnpApi === "function") {
    const pnpApi = _module.findPnpApi(from);
    if (pnpApi) {
      resolvedID = pnpApi.resolveRequest(id, from);
    }
  }
  const require2 = createRequire(from);
  return require2.resolve(resolvedID);
};
export {
  requireResolve
};
//# sourceMappingURL=requireResolve.js.map
